import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ProductPage from "../pages/product/page";
import FavoritesPage from "../pages/favorites/page";
import CheckoutPage from "../pages/checkout/page";
import OrderConfirmationPage from "../pages/checkout/confirmation";
import AuthPage from "../pages/auth/page";
import AccountOrdersPage from "../pages/account/orders";
import AccountDashboardPage from "../pages/account/page";
import CollectionPage from "../pages/collection/page";
import GiftCardsPage from "../pages/gift-cards/page";
import StoryPage from "../pages/story/page";
import HelpPage from "../pages/help/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/product/:id",
    element: <ProductPage />,
  },
  {
    path: "/favorites",
    element: <FavoritesPage />,
  },
  {
    path: "/checkout",
    element: <CheckoutPage />,
  },
  {
    path: "/order-confirmation/:id",
    element: <OrderConfirmationPage />,
  },
  {
    path: "/auth",
    element: <AuthPage />,
  },
  {
    path: "/account",
    element: <AccountDashboardPage />,
  },
  {
    path: "/account/orders",
    element: <AccountOrdersPage />,
  },
  {
    path: "/collection/:slug",
    element: <CollectionPage />,
  },
  {
    path: "/gift-cards",
    element: <GiftCardsPage />,
  },
  {
    path: "/story",
    element: <StoryPage />,
  },
  {
    path: "/help",
    element: <HelpPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;